import { render, staticRenderFns } from "./pendingMerchant.vue?vue&type=template&id=c3b34e36"
import script from "./pendingMerchant.vue?vue&type=script&lang=js"
export * from "./pendingMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports